/* TWM motion. Content no longer animates in on scroll: every section is
   visible as soon as it loads. What motion remains is CSS (assets/twm-motion.css:
   the home hero entrance, hover / press feedback, drawers, menus, tabs, FAQ)
   plus the home hero effects in assets/twm-home-motion.js.

   This script only tells the head script in layout/theme.liquid that motion
   started, so it keeps html.twm-motion (which the hero entrance hangs off). */
;(() => {
  if (!document.documentElement.classList.contains('twm-motion')) return
  window.__twmMotion = true
})()
